module.exports = __webpack_public_path__ + "static/media/ic_close.6ec59781.svg";